import React from 'react';
import cs from 'classnames';
import trim from 'lodash/trim';
import isEmpty from 'lodash/isEmpty';
import {push as changeURL} from 'react-router-redux';
import includes from 'lodash/includes';

import store from '~/store';
import Button from '~/components/common/Button';
import BillingInfomation from '../../MyAccount/share/BillingInfomation';
import {regEmail, regZip, regZipCanada, regPhone} from '~/misc/reg';
import {errorInfoConfig} from '~/misc/error-info';
import {saveBsicInfo} from '~/modules/hp/actions';
import {formatPhone, formatNumberOnly, formatCanadaZip} from '~/misc/formatPhone';
import {track} from '~/misc/metrics';

import css from './index.css';
import sharedCss from '../index.css';

class HpBillingInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 3,
      formData: {
        billState: '',
        billCountry: 'United States',
        billFirstname: '',
        billLastname: '',
        billPhone: '',
        billEmail: '',
        billAddress: '',
        billCity: '',
        billZip: '',
      },
      formControl: {},
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.goToBack = this.goToBack.bind(this);
    this.gotToNext = this.gotToNext.bind(this);
    this.formatData = this.formatData.bind(this);
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    this.props.changeNavItem(this.state.currentStep);

    // const user = this.props.user;
    const account = this.props.account.userInfo.data ? this.props.account.userInfo.data : {};

    const hpBillInfo = isEmpty(this.props.hp.hpPaymentInfo.data)
      ? {}
      : this.props.hp.hpPaymentInfo.data[0].billing_info;

    const initFormData = {
      billState: hpBillInfo.state || account.billState || 'AK',
      billCountry: hpBillInfo.country || account.billCountry || 'United States',
      billFirstname: hpBillInfo.first_name || account.billFirstname || '',
      billLastname: hpBillInfo.last_name || account.billLastname || '',
      billPhone: formatPhone(hpBillInfo.phone) || formatPhone(account.billPhone) || '',
      billEmail: hpBillInfo.email || account.billEmail || '',
      billAddress: hpBillInfo.street_address || account.billAddress || '',
      billCity: hpBillInfo.city || account.billCity || '',
      billZip: hpBillInfo.zip || account.billZip || '',
    };

    const data = Object.assign(initFormData, this.props.parentState.formData.step3.formData);
    this.setState({
      formData: data,
    });
  }

  render() {
    const formData = this.state.formData;
    return (
      <div className={css.wrap}>
        <BillingInfomation
          billingInfo={this.state.formData}
          errorControl={this.state.formControl}
          handleToggle={this.handleToggle}
          handleChange={this.handleChange}
          handleBlur={this.handleBlur}
        />
        <div className={sharedCss.btnWrap}>
          <Button onClick={this.goToBack} className={cs(sharedCss.wide)} mods={['large']} >Back</Button>
          {(formData.billCountry
            && formData.billCity
            && formData.billState
            && formData.billZip
            && formData.billEmail
            && formData.billPhone
            && formData.billLastname
            && formData.billFirstname
            && formData.billAddress)
            ? (<Button
              onClick={this.gotToNext}
              className={cs(sharedCss.marginLef, sharedCss.wide)}
              mods={['large', 'action']}
            >Next</Button>)
            : (<Button
              onClick={this.gotToNext}
              className={cs(sharedCss.marginLef, sharedCss.wide)}
              mods={['large']}
            >Next</Button>)
          }
        </div>
      </div>
    );
  }

  goToBack() {
    this.props.changeStep(this.state.currentStep - 1);
    setTimeout(() => {
      this.props.setStepData(this.state.currentStep, this.state);
      store.dispatch(changeURL(this.props.parentState.navItem[this.props.parentState.step - 1].routing));
    }, 300);
  }

  gotToNextRoute() {
    this.props.changeStep(this.state.currentStep + 1);
    setTimeout(() => {
      this.props.setStepData(this.state.currentStep, this.state);
      store.dispatch(changeURL(this.props.parentState.navItem[this.props.parentState.step - 1].routing));
    }, 500);
  }

  processDataAndSetState(typeName, errorTips, inputVal, clickType) {
    return this.setState({
      formData: {
        ...this.state.formData,
        [typeName]: inputVal,
      },
      formControl: {
        ...this.state.formControl,
        [typeName]: {
          error: errorTips,
          onClick: clickType,
        },
      },
    });
  }

  regData(inputVal, emptyErrorTips, wrongErrorTips, regMethodType, typeName) {
    if (!inputVal) {
      return this.processDataAndSetState(typeName, emptyErrorTips, inputVal, false);
    }
    if (regMethodType && !regMethodType.test(inputVal)) {
      return this.processDataAndSetState(typeName, wrongErrorTips, inputVal, false);
    }
    return this.processDataAndSetState(typeName, '', inputVal, true);
  }

  formatData(name, type, inputVal) {
    switch (type) {
      case 'text': {
        return this.regData(inputVal, errorInfoConfig.text.empty, errorInfoConfig.text.wrong, false, name);
      }
      case 'zip': {
        if (this.state.formData.billCountry && this.state.formData.billCountry === 'United States') {
          return this.regData(
            formatNumberOnly(inputVal, 5),
            errorInfoConfig.zip.empty,
            errorInfoConfig.zip.wrong, regZip, name);
        }
        return this.regData(
          formatCanadaZip(inputVal),
          errorInfoConfig.zip.empty,
          errorInfoConfig.zip.wrong,
          regZipCanada,
          name);
      }
      case 'email': {
        return this.regData(
          inputVal,
          errorInfoConfig.email.empty,
          errorInfoConfig.email.wrong,
          regEmail,
          name);
      }
      case 'phone': {
        return this.regData(
          formatPhone(inputVal),
          errorInfoConfig.phone.empty,
          errorInfoConfig.phone.wrong,
          regPhone,
          name);
      }
    }
    return null;
  }

  handleBlur(e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = trim(e.target.value);
    this.formatData(name, type, inputVal);
  }
  handleChange(e) {
    const name = e.target.name;
    const type = e.target.getAttribute('data-inputType');
    const inputVal = e.target.value;
    this.formatData(name, type, inputVal);
  }

  filterEmptyInputVal(formData) {
    let emptyValue = {};
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        if (key === 'billEmail') {
          emptyValue[key] = {
            error: errorInfoConfig.email.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'billZip') {
          emptyValue[key] = {
            error: errorInfoConfig.zip.empty,
            onClick: false,
          };
          return;
        }
        if (key === 'billPhone') {
          emptyValue[key] = {
            error: errorInfoConfig.phone.empty,
            onClick: false,
          };
          return;
        }
        emptyValue[key] = {
          error: errorInfoConfig.text.empty,
          onClick: false,
        };
        return;
      }
    });
    return emptyValue;
  }

  canClickOrNot(formControl) {
    let emptyValue = [];
    Object.keys(formControl).forEach((key, index) => {
      if (key !== 'companyMc') {
        if (formControl[key].onClick) {
          emptyValue[index] = true;
          return;
        } else if (formControl[key].onClick === false) {
          emptyValue[index] = false;
          return;
        }
      }
    });

    if (!includes(emptyValue.toString(), 'false')) {
      return true;
    }
    return false;
  }


  gotToNext() {
    track('payment', {'billing info - 3': 1});
    const formData = this.state.formData;
    const formControl = this.state.formControl;
    let emptyValue = this.filterEmptyInputVal(formData);
    const val = Object.assign(this.props.parentState.formData, {step3: this.state.formData});

    if (isEmpty(emptyValue) && this.canClickOrNot(formControl)) {
      this.gotToNextRoute();
      store.dispatch((dispatch, getState) => saveBsicInfo(dispatch, getState, val));
    } else {
      const controlData = Object.assign(this.state.formControl, emptyValue);

      this.setState({
        readError: this.state.haveRead ? '' : errorInfoConfig.readTerms.empty,
        formControl: controlData,
      });
    }
  }

  handleToggle(e) {
    if (this.state.formData[e.currentTarget.getAttribute('data-name')] === e.currentTarget.textContent) {
      return null;
    }

    this.processDataAndSetState(e.currentTarget.getAttribute('data-name'), '', e.currentTarget.textContent, true);

    // 如果toggle的是country init state 和zip 值
    if (e.currentTarget.getAttribute('data-name') === 'billCountry') {
      setTimeout(() => {
        this.processDataAndSetState('billState', errorInfoConfig.text.empty, '', false);
      }, 0);
      setTimeout(() => {
        this.processDataAndSetState('billZip', errorInfoConfig.text.empty, '', false);
      }, 0);
    }
    return null;
  }
}

export default HpBillingInformation;



// WEBPACK FOOTER //
// ./src/components/pages/PaymentProcess/HpBillingInformation/index.js